import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function CanvasFormToSendValidationReducer(state = initialState.canvasFormToSendValidation, action) {
	switch (action.type) {
		case types.GET_CANVAS_FORM_VALIDATION: {
			let validationDetails = action.response?.find(x => x.documentId == action.documentId);
			if (validationDetails && _.size(validationDetails)>0) {
                let newState = { ...state };
                newState[action.documentId] = validationDetails.validationCount > 0 ? true : false;
				return newState;
			}
			return state;
		}
		default:
			return state;
	}
}
